// @ts-strict-ignore
import { Component } from "@angular/core";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import * as C from "../../../../../../shared/constants/globals.constants";

@Component({
  selector: C.EWIZ_GBA_USER_AUTHENTICATION,
  templateUrl: "./gba-user-authentication.component.html",
  standalone: false
})
export class EWizGBAUserAuthenticationComponent extends EWizDynamicBaseClassComponent {
  handleUpdate(_event?: any): void {
    //rssd-200
    this.profileValues.isimServiceTable.isimService2 = this.profileValues.isimConfiguration.gbaUserAuthentication === "1";
    this.handleFormEvents();
  }
}
